/**
 * Cincom ECM 3.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PropertyType = 'BINARY' | 'BOOLEAN' | 'DATE' | 'DOUBLE' | 'LONG' | 'NAME' | 'PATH' | 'REFERENCE' | 'STRING' | 'UNKNOWN' | 'URI' | 'DECIMAL';

export const PropertyType = {
    BINARY: 'BINARY' as PropertyType,
    BOOLEAN: 'BOOLEAN' as PropertyType,
    DATE: 'DATE' as PropertyType,
    DOUBLE: 'DOUBLE' as PropertyType,
    LONG: 'LONG' as PropertyType,
    NAME: 'NAME' as PropertyType,
    PATH: 'PATH' as PropertyType,
    REFERENCE: 'REFERENCE' as PropertyType,
    STRING: 'STRING' as PropertyType,
    UNKNOWN: 'UNKNOWN' as PropertyType,
    URI: 'URI' as PropertyType,
    DECIMAL: 'DECIMAL' as PropertyType
};
